import { useEffect, useRef, useState } from "react";

const useIsOverflowing = () => {
  const textRef = useRef<HTMLElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const element = textRef.current;
    if (element) {
      setIsOverflowing(element.scrollHeight > element.clientHeight);
    }
  }, [textRef]);

  return { textRef, isOverflowing };
};

export default useIsOverflowing;
